(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2488],{

/***/ 32014:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entrenamientos/official-product-backlog-management-certification-training",
      function () {
        return __webpack_require__(21625);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MarketingProgramSimple; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Check__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29468);
/* harmony import */ var _components_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30341);
/* harmony import */ var _MarketingSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71105);




function MarketingProgramSimple(param) {
    var program = param.program;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MarketingSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "bg-gradient-to-t from-gray-100 to-white",
        sectionTitle: "Temario del entrenamiento",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            maxWidth: "max-w-screen-lg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-y-16",
                children: program.map(function(param, index) {
                    var subject = param.subject, content = param.content;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex relative lg:col-span-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute z-0 top-0 left-0 text-6xl font-extrabold text-gray-500 pointer-events-none leading-none opacity-10 -mt-4 -ml-6",
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "relative w-full z-10 space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-xl font-medium",
                                        children: subject
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        className: "list-none space-y-2",
                                        children: content.map(function(param, subjectIndex) {
                                            var title = param.title;
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                className: "flex items-start space-x-3 text-gray-500 hover:text-gray-700 cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "mt-px pt-px",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Check__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                            className: "text-green-400"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flex-1",
                                                        children: title
                                                    })
                                                ]
                                            }, "program-".concat(index, "-subject-").concat(subjectIndex));
                                        })
                                    })
                                ]
                            })
                        ]
                    }, "program-".concat(index));
                })
            })
        })
    });
};


/***/ }),

/***/ 21625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ TrainingMarketingPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _domain_Training_MarketingPageWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94664);
/* harmony import */ var _domain_Training_MarketingHero__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90493);
/* harmony import */ var _domain_Training_MarketingHighlightCopy__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18141);
/* harmony import */ var _domain_Training_MarketingContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13789);
/* harmony import */ var _domain_Training_MarketingTrainers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55344);
/* harmony import */ var _domain_Training_MarketingFeatures__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91873);
/* harmony import */ var _domain_Training_MarketingProgramSimple__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69631);
/* harmony import */ var _domain_Training_MarketingTestimonials__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28570);
/* harmony import */ var _domain_Training_MarketingFAQs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18346);
/* harmony import */ var _domain_Training_MarketingContact__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30398);












var __N_SSG = true;
function TrainingMarketingPage(param) {
    var training = param.training;
    var hasContent = training.content !== null;
    var hasTrainers = training.details.trainers !== null;
    var hasWhatIsLearned = training.details.whatIsLearned !== null;
    var hasProgramSubjects = training.details.programSubjects !== null;
    var hasTestimonials = training.details.testimonials !== null;
    var hasFAQs = training.details.faqs !== null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_domain_Training_MarketingPageWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_domain_Training_MarketingHero__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                heroCopy: "Product Backlog Management",
                heroLead: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "leading-relaxed",
                    children: [
                        "El programa de entrenamiento\xa0",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            className: "text-gray-900",
                            children: "m\xe1s completo para hispanohablantes"
                        }),
                        "\xa0donde adquieres y desarrollas las competencias necesarias para dominar la gesti\xf3n de un \xa0",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            className: "text-gray-900",
                            children: "Product Backlog"
                        }),
                        "."
                    ]
                }),
                heroImage: "v1705344536/personas/twyy7ze6bqo0gipfjoyn.png",
                heroImageAlt: "Official Product Backlog Management Training",
                heroCTANormalClasses: "bg-teal-600",
                heroCTAHoverClasses: "hover:bg-teal-700",
                heroCTAFocusClasses: "focus:bg-teal-700 focus:ring-teal-600 focus:ring-opacity-20",
                heroHighlighColor: "text-teal-600",
                heroBackgroundFrom: "from-teal-100",
                heroBackgroundTo: "to-white",
                stripesBackgroundFrom: "from-teal-500",
                stripesBackgroundTo: "to-transparent",
                stripesBackgroundDarkerFrom: "from-teal-600",
                stripesBackgroundDarkerTo: "to-transparent"
            }, training.details)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_domain_Training_MarketingHighlightCopy__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "leading-relaxed",
                    children: [
                        "El programa\xa0",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            className: "font-semibold text-white",
                            children: "Product Backlog Management"
                        }),
                        "\xa0te capacita de manera pr\xe1ctica para la gesti\xf3n de un\xa0",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            className: "font-semibold text-white",
                            children: "Product Backlog"
                        }),
                        "\xa0eficiente que te permita liderar problemas complejos entregando valor."
                    ]
                })
            }),
            hasContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_domain_Training_MarketingContent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                content: training.content
            }),
            hasTrainers && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_domain_Training_MarketingTrainers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                trainers: training.details.trainers
            }),
            hasWhatIsLearned && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_domain_Training_MarketingFeatures__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                features: training.details.whatIsLearned
            }),
            hasProgramSubjects && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_domain_Training_MarketingProgramSimple__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                program: training.details.programSubjects
            }),
            hasTestimonials && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_domain_Training_MarketingTestimonials__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                testimonials: training.details.testimonials
            }),
            hasFAQs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_domain_Training_MarketingFAQs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                faqs: training.details.faqs
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_domain_Training_MarketingContact__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,3022,9774,2888,179], function() { return __webpack_exec__(32014); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);